import moment from 'moment';
import { FeedSource } from '../../interfaces/FeedSource';
import { IFeed } from '../../interfaces/IFeed';
import elMundoLogo from './../../images/elMundoLogo.png';
import elPaisLogo from './../../images/elPaisLogo.png';

import './Feed.css';

function Feed({ content: feed }: { content: IFeed }) {
  return (
    <div className="Feed">
      <a href={feed.url} target="_blank" rel="noreferrer">
        <img
          alt={
            feed.source === FeedSource.EL_MUNDO ? 'elMundoLogo' : 'elPaisLogo'
          }
          src={feed.source === FeedSource.EL_MUNDO ? elMundoLogo : elPaisLogo}
          height={30}
        />
        <header className="Feed_header">
          <p>
            <b>{feed.title}</b>
          </p>
        </header>
        <div className="Feed_body">
          <p>{feed.description}</p>
        </div>
        <div className="Feed_footer">
          <p>{moment(feed.createdAt).format('DD/MM/YYYY HH:mm')}</p>
        </div>
        <p>
          <i>{feed.author.split('|')[0].toUpperCase()}</i>
        </p>
      </a>
    </div>
  );
}

export default Feed;
